import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment.development';
import { initializeApp } from 'firebase/app';
import { getMessaging, onMessage, Messaging } from 'firebase/messaging';
import { from, Observable } from 'rxjs';
import { FirebaseInitService } from './firebase-init.service';
import { CaseManagementAPI } from '../constant/url.constant';
import { updateFaviconWithDot } from './favicon-util';
import { SharedCaseManagementService } from './shared-case-management.service';
import { DateTime } from 'luxon';

@Injectable({ providedIn: 'root' })
export class FcmService {
  private readonly messaging: Messaging;

  constructor(
    private readonly http: HttpClient,
    private readonly firebaseInit: FirebaseInitService,
    private readonly sharedCaseManagementService: SharedCaseManagementService
  ) {
    // ✅ Manual Firebase initialization
    const firebaseApp = initializeApp(environment.firebase);
    this.messaging = getMessaging(firebaseApp);
  }

  requestPermissionAndGetToken$(): Observable<string | null> {
    return from(
      Notification.requestPermission().then((permission: any) => {
        if (permission === 'granted') {
          return this.firebaseInit.getFCMToken().then((token: any) => {
            if (token) {
              return token as string;
              // 🔁 Here you can call your API to send token to backend
            } else {
              console.warn('⚠️ No FCM token returned');
              return null;
            }
          });
        } else {
          console.warn('❌ Notification permission denied');
          return null;
        }
      }).then((result) => result ?? null)
    );
  }

  sendTokenToBackend(userId: string, agencyId: string, token: string) {
    const payload = {
      agencyId: agencyId,
      fcmToken: token
    };
    let headers = new HttpHeaders();
    if (userId) {
      headers = headers.set('user-id', userId);
    }
    const url = `${CaseManagementAPI.SendFCMToken}`;
    return this.http.post(url, payload, { headers });
  }

  listenToMessages() {
    onMessage(this.messaging, (payload: any) => {
      let body = JSON.parse(payload.data?.body || '{}');
      const newNotification = {
        title: payload.data?.title || 'New Notification',
        description: body?.description  || '',
        isRead: false,
        updatedDate: DateTime.now().toFormat('MM/dd/yyyy'),
        applicantName: body?.applicantName || 'Jake Park',
        type: 'dynamic',
        caseId: body?.caseId || 0,
        statusLabel: body?.statusLabel || '',
        notificationType: body?.notificationType || '',
        caseStatusId: body?.caseStatusId || 0,
        agencyId: body?.agencyId || 0,
      };
      this.sharedCaseManagementService.updateNotification(newNotification);
      if (document.visibilityState !== 'visible') {
        updateFaviconWithDot('assets/images/favicon.png');
      }
    });
  }
  listenToBroadcastChannel() {
    const broadcast = new BroadcastChannel('fcm_channel');
    broadcast.onmessage = (event) => {
      const { type } = event.data;
      let body = JSON.parse(event.data?.data?.data?.body || '{}');
      if (type === 'BACKGROUND_NOTIFICATION') {
        const newNotification = {
          title: event.data?.data?.data?.title || 'New Notification',
          description: body?.description  || '',
          isRead: false,
          updatedDate: DateTime.now().toFormat('MM/dd/yyyy hh:mm:ss a'),
          applicantName: body?.applicantName || 'Jake Park',
          type: 'dynamic',
          caseId: body?.caseId || 0,
          statusLabel: body?.statusLabel || '',
          notificationType: body?.notificationType || '',
          caseStatusId: body?.caseStatusId || 0,
          agencyId: body?.agencyId || 0,
        };
        this.sharedCaseManagementService.updateNotification(newNotification);

        if (document.visibilityState !== 'visible') {
          updateFaviconWithDot('assets/images/favicon.png');
        }
      }
    };
  }
}
